import { getMessageConfig } from '@utils/messageConfig';
import { isHeadMultiPoi } from '@utils/ids';
import { getCookie } from '@utiljs/cookie';

import { FRAME_NAME, getFrameByName } from '../utils/subFrames';

const initIm = () => {
    if (isHeadMultiPoi() && getMessageConfig().imNotification === false) return;

    const doInitIm = () => {
        const imIframe = document.createElement('iframe');
        imIframe.setAttribute('id', 'J-imframe');
        imIframe.setAttribute('name', 'J-imframe');
        imIframe.style.position = 'fixed';
        document.body.appendChild(imIframe);
        const target = getFrameByName(FRAME_NAME.IM);
        if (!target) {
            return;
        }
        target.location.replace('/new_fe/imChat_gw');
    };

    // 仅到店业务屏蔽 IM
    if (getCookie('onlyForDaoDianAcct') !== '1') {
        doInitIm();
    }
};

export default initIm;
